import { BadgeCheck, Loader } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const leaders = [
  { name: "Lorenzo Openito", role: "Founder, Owner & CEO", initials: "LO" },
  { name: "Yves Bwansa", role: "Chief Operating Officer", initials: "YB" },
];

const certs = [
  { label: "SOC 2 Type II", status: "In progress", done: false },
  { label: "ISO 27001", status: "In progress", done: false },
  { label: "HIPAA", status: "Advisory", done: false },
  { label: "GDPR / CCPA", status: "Program in place", done: true },
];

export function Trust() {
  return (
    <section id="about" className="bg-black py-24 lg:py-36 border-t border-white/10" data-testid="trust-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-fog mb-4">About Aliwer</p>
          <h2 className="font-display text-3xl sm:text-5xl tracking-tight text-paper max-w-[18ch]">
            Built by security operators, trusted by teams.
          </h2>
          <p className="mt-6 text-sm text-fog leading-relaxed max-w-xl">
            Aliwer is a technology systems and cybersecurity consulting company delivering
            outcomes through a trusted ecosystem of vetted experts — and our own AI security
            products, BArecord and SecureDesk.
          </p>
        </Reveal>

        {/* Leadership */}
        <div className="mt-14 grid gap-4 sm:grid-cols-2 max-w-2xl" data-testid="trust-leadership">
          {leaders.map((l, i) => (
            <Reveal key={l.name} delay={i * 0.06}>
              <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-surface p-5">
                <div className="h-12 w-12 rounded-full bg-white/10 flex items-center justify-center font-display text-paper tracking-tight">
                  {l.initials}
                </div>
                <div>
                  <p className="font-display text-lg tracking-tight text-paper">{l.name}</p>
                  <p className="text-xs uppercase tracking-widest text-fog mt-0.5">{l.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Certifications strip */}
        <div className="mt-16" data-testid="trust-certs">
          <p className="text-xs uppercase tracking-widest text-fog mb-5">Security &amp; privacy program</p>
          <div className="flex flex-wrap gap-3">
            {certs.map((c) => (
              <span key={c.label} className="inline-flex items-center gap-2.5 rounded-full border border-white/15 pl-4 pr-2 py-1.5 text-sm text-paper/90">
                {c.done ? <BadgeCheck size={15} className="text-green-400" /> : <Loader size={14} className="text-yellow-400" />}
                {c.label}
                <span className={`text-[10px] uppercase tracking-widest rounded-full px-2 py-0.5 border ${
                  c.done ? "border-green-400/30 text-green-400" : "border-yellow-400/30 text-yellow-400"
                }`}>
                  {c.status}
                </span>
              </span>
            ))}
          </div>
          <p className="mt-4 text-xs text-fog/80 max-w-xl leading-relaxed">
            We publish our compliance status honestly — no framework is claimed as certified until the
            audit is complete. Follow the live timeline on our SOC 2 journey page.
          </p>
        </div>
      </div>
    </section>
  );
}
